export default "__VITE_ASSET__155a8683__"